const initialState = {
    products: [],
    item_types: [],
    designers: [],
    models: [],
    styles: [],
    sizes: [],
    selected_item_type: null,
    selected_item_type_category: null,
    selected_designer: null,
    selected_model: null,
    selected_style: null,
    selected_size: null,
    selected_sku: null,
    search_results: [],
    search_results_total: 0,
    instant_sell_step: "bag",
    error_message: '',
    sku_price_evolution_list: {},
    sku_price_evolution_list_count: 0,
    ir_in_progress: false,
    ir_size_selection_progress: false,
    prediction: null,
    custom_fields_and_imgs: null,
    image_submission_current_step: 1,
    evaluation_sandbox: {},
    show_most_wanted_modal: false,
    show_exit_sell_now_modal: false,
    clair_order_ids: {},
    offers: [],
    other_offers: [],
    homeAddress: null,
    partnerCodeVerified: false,
    partnerCodeValue: "",
    partnerCodeError: "",
    show_rplus_redirect_sell_now_modal: false,
}

export default function sellNowReducer(state=initialState, action) {
    switch (action.type) {
        case 'INFO':
            return {
                ...state,
                error_message: action.error_message
            }
        case 'SHOW_SPINNER':
            return {
                ...state,
                isFetching: true
            }
        case 'HIDE_SPINNER':
            return {
                ...state,
                isFetching: false
            }
        case 'SET_FLOW_STEP':
            delete action.type;
            return {
                ...state,
                ...action
            }
        case 'SEARCH_RESULTS':
            return {
                ...state,
                search_finished: action.search_finished,
                has_more: action.search_next + action.search_page_size < 100,
                search_term: action.search_term,
                search_results: action.search_results,
                search_results_total:  action.search_results.length //action.search_results_total
            }
        case 'RESET_SEARCH':
            return {
                ...state,
                search_term: '',
                search_results: [],
                search_results_total: 0
            }
        case "RESET_FLOW":
            return {
                ...state,
                error_message: '',
                designers: [],
                models: [],
                styles: [],
                sizes: [],
                selected_item_type_category: null,
                selected_item_type: null,
                selected_designer: null,
                selected_model: null,
                selected_style: null,
                selected_size: null,
                selected_sku: null
            }
        case 'SET_ITEM_TYPE':
            return {
                ...state,
                selected_item_type_category: action.selected_item_type_category,
                selected_item_type: action.selected_item_type
            }
        case 'GET_ITEM_TYPES':
            return {
                ...state,
                item_types: action.item_types
            }
        case 'GET_SELL_NOW_PURCHASES':
            return {
                ...state,
                previous_purchases: action.previous_purchases
            }
        case 'GET_CUSTOM_FIELDS_AND_IMGS':
            return {
                ...state,
                custom_fields_and_imgs: action.custom_fields_and_imgs
            }
        case 'RESET_ITEM_TYPE':
            return {
                ...state,
                selected_sku: null,
                designers: [],
                selected_item_type_category: null,
                selected_item_type: null,
                selected_designer: null,
                selected_model: null,
                selected_style: null,
                selected_size: null,
                search_term: '',
                search_results: [],
                search_results_total: 0
            }
        case 'RESET_DESIGNER':
            return {
                ...state,
                selected_sku: null,
                models: [],
                selected_designer: null,
                selected_model: null,
                selected_style: null,
                selected_size: null,
                search_term: '',
                search_results: [],
                search_results_total: 0
            }
        case 'RESET_MODEL':
            return {
                ...state,
                selected_sku: null,
                models: [],
                selected_model: null,
                selected_style: null,
                selected_size: null
            }
        case 'RESET_STYLE':
            return {
                ...state,
                selected_sku: null,
                styles: [],
                selected_style: null,
                selected_size: null
            }
        case 'RESET_SIZE':
            return {
                ...state,
                selected_sku: null,
                sizes: [],
                selected_size: null
            }
        case 'GET_DESIGNERS':
            return {
                ...state,
                selected_item_type: action.item_type,
                designers: action.designers
            }
        case 'SELECT_DESIGNER':
            return {
                ...state,
                selected_designer: action.designer,
                models: action.models
            }
        case 'SELECT_MODEL':
            return {
                ...state,
                selected_model: action.model,
                styles: action.styles
            }
        case 'SELECT_STYLE':
            return {
                ...state,
                selected_style: action.style,
                sizes: action.sizes
            }
        case 'SELECT_SIZE':
            if(1 === action.search_results_total){
                return {
                    ...state,
                    selected_sku: action.search_results.hit[0].fields,
                    current_step: 2
                }
            }

            return {
                ...state,
                search_results: action.search_results,
                search_results_total: action.search_results_total
            }
        case 'ITEM_DETAILS':
            return {
                ...state,
                accessories: action.accessories,
                serial_number: action.serial_number,
                color: action.color,
                condition_key: action.condition_key
            }
        case 'SET_SKU':
            const pv = action.pv;
            return {
                ...state,
                selected_sku: pv,
                prediction: action.prediction,
                error_message: (pv && pv.message && 'photo_upload' !== pv.status) ? pv.message : '',
                show_sku_carousel_popup: false
            }
        case 'SAVE_INSTANT_OFFER':
            return {
                ...state,
                current_instant_offer: action.current_instant_offer
            }
        case 'SET_ACTIVE_OFFERS':
            return {
                ...state,
                offers: action.offers
            }
        case 'SET_OTHER_OFFERS':
            return {
                ...state,
                other_offers: action.offers
            }
        case 'SET_PREVIOUS_PURCHASES':
            return {
                ...state,
                prev_purchases: action.prev_purchases
            }
        case 'THANK_YOU':
            return {
                instant_sell_step: 'thankyou',
                error_message: '',
                shipping_method: action.shipping_method,
                shipping_address: action.shipping_address,
                pickup_date: action.pickup_date,
                pickup_interval_start: action.pickup_interval_start,
                pickup_instructions: action.pickup_instructions,
                order_id: action.order_id
            }
        case 'SET_SKU_PRICE_EVOLUTION':
            const current_price_evolution_list = state.sku_price_evolution_list;
            current_price_evolution_list[action.sku] = action.sku_price_evolution;
            return {
                ...state,
                ...current_price_evolution_list
            }
        case 'IR_IN_PROGRESS':
            return {
                ...state,
                ir_in_progress: action.ir_in_progress
            }
        case 'IR_SIZE_SELECTION_IN_PROGRESS':
            return {
                ...state,
                ir_size_selection_progress: action.payload
            }
        case 'SET_IMAGE_SUBMISSION_CURRENT_STEP':
            return {
                ...state,
                image_submission_current_step: action.current_step
            }
        case 'SET_EVALUATION_SANDBOX':
            return {
                ...state,
                evaluation_sandbox: action.evaluation
            }
        case 'SET_SHOW_MOST_WANTED_MODAL':
            return {
                ...state,
                show_most_wanted_modal: action.show_modal
            }
        case 'SET_EXIT_SELL_NOW_MODAL':
            return {
                ...state,
                show_exit_sell_now_modal: action.show_modal
            }
        case 'SET_RPLUS_REDIRECT_SELL_NOW_MODAL':
            return {
                ...state,
                show_rplus_redirect_sell_now_modal: action.show_modal
            }
        case 'CLAIR_CHECKOUT_FINISHED':
            return {
                ...state,
                clair_order_ids: action.clair_order_ids
            }
        case 'SET_HOME_ADDRESS':
            return {
                ...state,
                homeAddress: action.payload
            }
        case 'SET_PARTNER_CODE_DATA':
            return {
                ...state,
                partnerCodeVerified: true,
                partnerCodeValue: action.payload,
            }
        case 'RESET_PARTNER_CODE_DATA':
            return {
                ...state,
                partnerCodeVerified: false,
                partnerCodeValue: "",
            }
        case 'SET_PARTNER_CODE_ERROR':
            return {
                ...state,
                partnerCodeVerified: false,
                partnerCodeError: action.payload,
            }
        default:
            return state;
    }
}